module.exports = __webpack_public_path__ + "img/tellogo.186ac60e.png";